import { createContext, useContext, type ReactNode } from "react";

// Opt-in leading-gutter alignment for a stack of automation node fields. When a
// node body wraps its controls in <FieldGutterProvider>, every FieldSelect /
// FieldEntitySelect / FieldMultiEntitySelect inside centers its glyph (icon or
// avatar) in a fixed-width leading slot, so value text lines up in one column
// across rows whose glyphs differ in size. Rows with no glyph render no slot —
// their text hugs the leading edge instead of sitting after an empty gutter.
// Controls OUTSIDE a provider (e.g. the trigger header's source select) keep
// their natural, glyph-hugging layout.
const FieldGutterContext = createContext(false);

export function FieldGutterProvider({ children }: { children: ReactNode }) {
  return (
    <FieldGutterContext.Provider value={true}>
      {children}
    </FieldGutterContext.Provider>
  );
}

export function useFieldGutter(): boolean {
  return useContext(FieldGutterContext);
}
